module.exports = __webpack_public_path__ + "img/2.1630993415105.png";